export enum ActionsDropdownMessages {
  EditLabel = 'Edit',
  DeleteLabel = 'Delete',
  DescriptionLabel = 'Are you sure you want to delete it?',
}
